import { GetterTree } from 'vuex';
import { IRootState } from '@/store/types';
import actions from './actions';
import mutations from './mutations';
import { IState } from './types';

const state: IState = {
  info: {
    login: false
  }
};

const getters: GetterTree<IState, IRootState> = {
  isLogin(state) {
    return state.info.login;
  },
  sandboxUserId(state) {
    return state.info.userId;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
